import { Pipe, PipeTransform, inject } from '@angular/core';
import { AdminBoxStatus } from '../enums/admin-box-status';
import { Observable } from 'rxjs';
import { AdminBoxStatusProviderService } from '../providers/admin-box-status-provider.service';

@Pipe({
  name: 'adminBoxStatus',
})
export class AdminBoxStatusPipe implements PipeTransform {
  private readonly provider = inject(AdminBoxStatusProviderService);

  public transform(status: AdminBoxStatus): Observable<string> {
    return this.provider.labelFor(status);
  }
}
